export default __webpack_public_path__ + "static/media/14_thumbnail.a1c61118.JPG";